import React from 'react'

interface ChevronRightIconProps {
  color?: string
  size?: number
}

/**
 * Chevron right icon for collapsed state
 */
const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  color = '#797B7E',
  size = 24,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
    >
      <path
        d='M9.00002 7.21124C8.61002 7.60124 8.61002 8.23124 9.00002 8.62124L12.88 12.5012L9.00002 16.3812C8.61002 16.7712 8.61002 17.4012 9.00002 17.7912C9.39002 18.1812 10.02 18.1812 10.41 17.7912L15 13.2012C15.39 12.8112 15.39 12.1812 15 11.7912L10.41 7.20124C10.03 6.82124 9.39002 6.82124 9.00002 7.21124Z'
        fill={color}
      />
    </svg>
  )
}

export default ChevronRightIcon
